import { UltrabufEntries, type ICommandData } from '@tencent/slide-sdk-pb-model';
import { Base64String } from '../utils/base64-utils';
import { CommandData } from './command-data';
import { SlideCodec } from './slide-codec';
import type { IMutationData, IRevision } from '@tencent/slide-sdk-pb-model';
import type { IValidMutationData } from '../mutation/base';

export class RevisionData {
    public static empty = new RevisionData({});

    public static fromBufferOrBase64(buffer: Uint8Array | string) {
        const data = SlideCodec.codec.decode(buffer, UltrabufEntries.Revision);
        return new RevisionData(data);
    }

    public static fromCommandData(commands: ICommandData[]) {
        return new RevisionData({
            commands,
        });
    }

    private data: IRevision;

    public constructor(data: IRevision) {
        this.data = { commands: [], ...data };
    }

    public toBase64String(): string {
        const buf = SlideCodec.codec.encode(this.data, UltrabufEntries.Revision);
        return Base64String.fromUint8Array(buf);
    }

    public getRevisionData() {
        return this.data;
    }

    public getCommandData(): ICommandData[] {
        return this.data.commands ?? [];
    }

    public getMutationData(): IMutationData[] {
        return this.getCommandData().flatMap((command) => command.mutations ?? []);
    }

    public getValidMutationData(): IValidMutationData[] {
        return this.getCommandData().flatMap((command) => CommandData.from(command).getValidMutationData());
    }
}
